import { IContentLanguage } from '@shared/models/multilanguage-model';
import { ILanguage } from '../languages-service/languages-model';

export interface ITimeline {
    id: string;
    advancedTemplateId: string;
    advancedTemplateName: string;
    advancedTemplateCustomDomain: string;
    eventSenderSettingId: string;
    registrationPageId: string;
    informationPageId: string;
    agendaPageId: string;
    surveyPageId: string;
    surveyActiveDeclinePageId: string;
    surveyPassiveDeclinePageId: string;
    invitationMailId: string;
    confirmationMailId: string;
    reminderMailId: string;
    internalReminderMailId: string;
    welcomeMailId: string;
    thankYouMailId: string;
    ticketMailId: string;
    saveDateMailId: string;
    paymentDocumentMailId: string;
    registrationPageFromDate: Date;
    registrationPageToDate: Date;
    invitationMailFromDate: Date;
    invitationMailToDate: Date;
    agendaPageActive: boolean;
    surveyPageActive: boolean;
    surveyActiveDeclinePageActive: boolean;
    surveyPassiveDeclinePageActive: boolean;
    informationPageActive: boolean;
    invitationMailActive: boolean;
    confirmationMailActive: boolean;
    internalReminderMailActive: boolean;
    reminderMailActive: boolean;
    thankYouMailActive: boolean;
    welcomeMailActive: boolean;
    saveDateMailActive: boolean;
    paymentDocumentMailActive: boolean;
    saveDateMailSendDate: Date;
    saveDateMailIsProcessed: boolean;
    daysBefore: number;
    daysAfter: number;
    reminderWithin: number;
    internalReminderBefore: number;
    adHocMailData: Array<IAdHocMail>;
    from: string;
    replyto: string;
    customPageId: string;
    customPageActive: string;
    registrationPageToDateDays: number;
    webinarWelcomePageId: string;
    webinarThankYouPageId: string;
    galleryPageId: string;
    galleryPageActive: string;
    speakersPageId: string;
    speakersPageActive: string;
    workshopsPageId: string;
    workshopsPageActive: string;
}

export interface IAdHocMail {
    adHocMailId: string;
    name: string;
    sendDate: Date;
    isActive: boolean;
    isProcessed: boolean;
}

export interface IPublicUrls {
    publicUrls: IPublicUrl[];
}

export class PublicUrls implements IPublicUrls {
    constructor(
        public publicUrls: IPublicUrl[]
    ) { }
}

export interface IPublicUrl {
    url: string;
    languageId: string;
}

export class PublicUrl implements IPublicUrl {
    constructor(
        public url: string,
        public languageId: string
    ) { }
}

export interface IUpdateAdvancedTemplate {
    eventId: string;
    advancedTemplateId: string;
}

export class UpdateAdvancedTemplate implements IUpdateAdvancedTemplate {
    constructor(
        public eventId: string,
        public advancedTemplateId: string
    ) { }
}

export interface IUpdateLanguages {
    eventId: string;
    languages: ILanguage[];
}

export class UpdateLanguages implements IUpdateLanguages {
    constructor(
        public eventId: string,
        public languages: ILanguage[]
    ) { }
}

export interface ITimelineWizard {
    advancedTemplateId: string;
    languages: ILanguage[];
    bannerContent: IContentLanguage[];
}

export class TimelineWizard implements ITimelineWizard {
    constructor(
        public advancedTemplateId: string,
        public languages: ILanguage[],
        public bannerContent: IContentLanguage[]
    ) { }
}

export interface IUpdateTimelineWizard {
    eventId: string;
    advancedTemplateId: string;
    bannerContent: IContentLanguage[];
}

export class UpdateTimelineWizard implements IUpdateTimelineWizard {
    constructor(
        public eventId: string,
        public advancedTemplateId: string,
        public bannerContent: IContentLanguage[]
    ) { }
}

export interface IFromReplyto {
    fromType: string;
    fromName: string;
    fromEmail: string;
    replyToType: string;
    replyToEmail: string;
}

export class FromReplyto implements IFromReplyto {
    constructor(
        public fromType: string,
        public fromName: string,
        public fromEmail: string,
        public replyToType: string,
        public replyToEmail: string
    ) { }
}

export class FromReplytoVm {
    public static getDomain(email: string) {
        const splitted = email.split('@');
        if (splitted.length === 2) {
            const host = splitted[0];
            const domain = splitted[1];
            return domain;
        }
        return '';
    }

    private constructor(
        public fromType: string,
        public fromName: string,
        public fromEmail: string,
        public replyToType: string,
        public replyToEmail: string,
    ) {

    }

    public static create(entity: IFromReplyto): FromReplytoVm {
        return new FromReplytoVm(entity.fromType, entity.fromName, entity.fromEmail, entity.replyToType, entity.replyToEmail);
    }

    public getEntity(): IFromReplyto
    {
        return new FromReplyto(this.fromType, this.fromName, this.fromEmail, this.replyToType, this.replyToEmail);
    }
}

export interface IUpdateFromReplyto {
    eventId: string;
    fromType: string;
    fromName: string;
    fromEmail: string;
    replyToType: string;
    replyToEmail: string;
}

export class UpdateFromReplyto implements IUpdateFromReplyto {
    constructor(
        public eventId: string,
        public fromType: string,
        public fromName: string,
        public fromEmail: string,
        public replyToType: string,
        public replyToEmail: string
    ) { }
}
